<template>
  <div v-if="isCsmMode" class="csm-banner">
    <div class="container">
      Сайт в режиме работы оператора КЦ

      <ui-button
        class="csm-banner__button"
        text="Выйти"
        secondary
        small
        :loading="isLoading"
        @click="exit"
      />
    </div>
  </div>
</template>

<script>

import { mapActions } from 'vuex';

import {
  isCSMFailAuth, isCsmMode, resetCSMFailCookie,
  resetMode,
} from '@/utils/cookies/csm-cookies';

export default {
  name: 'csm-banner',

  data() {
    return {
      isCsmMode: false,
      isLoading: false,
    };
  },

  mounted() {
    this.isCsmMode = isCsmMode();

    if (isCSMFailAuth()) {
      this.ADD_NOTIFICATION({ title: 'Ошибка авторизации: клиент не найден' });
      resetCSMFailCookie();
    }
  },

  methods: {
    ...mapActions({ ADD_NOTIFICATION: 'notifications/create' }),

    exit() {
      this.isLoading = true;
      resetMode();
      location.assign('/');
    },
  },
};
</script>

<style lang="scss">
  .csm-banner {
    background: $black;
    color: $white;
    font-weight: bold;
    padding: 10px;
    text-align: center;

    .csm-banner__button {
      margin-left: 8px;
    }

    .container {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
</style>
